import React, { Component } from 'react'
import Section from '../shared/Section'
import SectionHeader from '../shared/Section/Header'
import TrialButton from '../shared/Trial'
import Features from './Features'
import { ReactComponent as AnalyticsImage } from './analytics.svg'
import { extendBaseClass, extend } from '../../utils/classes'

export class Analytics extends Component {
  baseClass = 'analytics'

  extend = extendBaseClass.bind(this)

  render() {
    const row = this.extend('row')
    const imageCol = extend(row, 'image-col')
    const content = extend(row, 'content')
    return (
      <Section>
        <div className={row}>
          <div className={imageCol}>
            <AnalyticsImage className={extend(imageCol, 'image')} />
          </div>
          <div className={content}>
            <SectionHeader
              headline="Real Time Data"
              title="Analytics To Optimize Your Messaging Funnel"
              description="Get real-time analytics that shows you your true chat volume, the time and days you’re busiest, your team’s engagement progress and more."
              parentClass={content}
            />
            <Features parentClass={content} />
            <TrialButton parentClass={content} />
          </div>
        </div>
      </Section>
    )
  }
}

export default Analytics
